import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:1000/api';

const NumberLinkForm = ({ onSubmit, role }) => {
  const [formData, setFormData] = useState({
    person_name: '',
    amount: '',
    payment_method: 'cash',
    type: 'Number Link',
    record_date: new Date().toLocaleDateString('en-CA', {
      timeZone: 'Asia/Kolkata'
    })
  });

  const [isShiftClosed, setIsShiftClosed] = useState(false);

  useEffect(() => {
    const checkShiftStatus = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_URL}/shift/${formData.record_date}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setIsShiftClosed(res.data.is_closed);
      } catch (err) {
        console.error('Failed to fetch shift status', err);
      }
    };
    checkShiftStatus();
  }, [formData.record_date]);

  const firstInputRef = useRef(null);

  useEffect(() => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      ...formData,
      person_name: '',
      amount: '',
      payment_method: 'cash',
      type: formData.type // Keep the last selected type
    });
    
    // Auto-focus the first field for the next fast entry
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  };

  return (
    <div className="dash-card">
      <form onSubmit={handleSubmit}>
        
        {/* Link Section */}
        <div className="form-section">
          <h4 className="form-section-title">{formData.type === 'PUC Reprint' ? 'PUC Reprint Details' : 'Number Link Details'}</h4>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="type">Service Type</label>
              <select 
                id="type" 
                name="type" 
                className="form-control"
                value={formData.type}
                onChange={handleChange}
                required
              >
                <option value="Number Link">Number Link</option>
                <option value="PUC Reprint">PUC Reprint</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="person_name">
                {formData.type === 'PUC Reprint' ? 'Customer / Vehicle Name' : 'Person Name'}
              </label>
              <input 
                type="text" 
                id="person_name" 
                name="person_name" 
                ref={firstInputRef}
                className="form-control"
                value={formData.person_name}
                onChange={handleChange}
                placeholder={formData.type === 'PUC Reprint' ? 'e.g. MH 01 AB 1234' : 'e.g. John Doe'}
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="amount">Amount (₹)</label>
              <input 
                type="number" 
                id="amount" 
                name="amount" 
                className="form-control"
                value={formData.amount}
                onChange={handleChange}
                placeholder="0.00"
                min="0"
                step="0.01"
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="payment_method">Payment Method</label>
              <select 
                id="payment_method" 
                name="payment_method" 
                className="form-control"
                value={formData.payment_method}
                onChange={handleChange}
                required
              >
                <option value="cash">Cash</option>
                <option value="paytm">Paytm / Online</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="record_date">Date</label>
              <input 
                type="date" 
                id="record_date" 
                name="record_date" 
                className="form-control"
                value={formData.record_date}
                onChange={handleChange}
                required 
              />
            </div>
          </div>
        </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary" disabled={isShiftClosed && role !== 'admin'} style={{ opacity: (isShiftClosed && role !== 'admin') ? 0.5 : 1 }}>
                {(isShiftClosed && role !== 'admin') ? 'Shift Closed for Date' : `Save ${formData.type}`}
              </button>
            </div>
      </form>
    </div>
  );
};

export default NumberLinkForm;
